<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="userParam" label-width="80px" class="unitWidth" size="small">
                <el-form-item :label="$t('base.name')">
                    <el-input v-model.trim="userParam.userName" :placeholder="$t('User.input')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.JobNo')">
                    <el-input v-model.trim="userParam.userAccount" :placeholder="$t('User.input')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.email')">
                    <el-input v-model.trim="userParam.userEmail" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <!--<el-form-item label="手机号码">
                    <el-input v-model.trim="userParam.userPhone" placeholder="请输入手机号码"></el-input>
                </el-form-item>-->
                <el-form-item :label="$t('base.ifEnable')">
                    <el-switch
                        v-model="userParam.isActive"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editUser">{{$t('base.confirm')}}</el-button>
                    <el-button type="primary" @click="addUserRoleShow">{{$t('User.AddRole')}}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <div class="tableBox">
            <el-table
                :data="userRolesList"
                style="width: 100%">
                <el-table-column
                    :label="$t('base.order')"
                    type="index"
                    width="70">
                </el-table-column>
                <el-table-column
                    :label="$t('User.RoleName')"
                    width="170"
                    prop="roleName">
                </el-table-column>
                <el-table-column
                    :label="$t('User.RoleLevel')"
                    width="170"
                    prop="roleLevel">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roleLevel == 'factory'">{{$t('User.gcLevel')}}</span>
                        <span v-if="scope.row.roleLevel == 'shop'">{{$t('User.cjLevel')}}</span>
                        <span v-if="scope.row.roleLevel == 'vsm'">{{$t('User.gdLevel')}}</span>
                        <span v-if="scope.row.roleLevel == 'line'">{{$t('User.cxLevel')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('Shift.factory')"
                    width="170"
                    prop="factoryName">
                </el-table-column>
                <el-table-column
                    :label="$t('User.workshop')"
                    width="170"
                    prop="shopName">
                </el-table-column>
                <el-table-column
                    :label="$t('User.section')"
                    width="170"
                    prop="sectionName">
                </el-table-column>
                <el-table-column
                    :label="$t('User.productLine')"
                    width="170"
                    prop="lineName">
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="180">
                    <template slot-scope="scope">
                        <i class="delBtn iconfont u-shanchu" @click="deleterole(scope)"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="30%">
            <el-form :inline="true" :model="userRoles" ref="userForm" label-width="100px" class="fform">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcIdSelected" :disabled="ischeck" filterable @change="fcChange" :placeholder="$t('base.PleaseSelect')">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('User.RoleName')">
                    <el-select v-model="roleIdSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                        <el-option
                            v-for="role in roleList"
                            :key="role.roleId"
                            :label="role.roleName"
                            :value="JSON.stringify(role)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('User.workshop')" v-if="hasShopSelect">
                    <el-select v-model="shopSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('User.section')" v-if="hashSectionSelect">
                    <el-select v-model="sectionSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('User.productLine')" v-if="hashLineSelect">
                    <el-select v-model="lineSelected" :placeholder="$t('base.PleaseSelect')" filterable>
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('base.cancel')}}</el-button>
            <el-button type="primary" @click="addUserRole">{{$t('base.confirm')}}</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import { deleteUserRole, userRole } from '../../../libs/api'

    export default {
        name: 'editUser',
        data(){
            return{
                userParam: {},
                userRolesList: [],
                dialogVisible: false,
                userRoles: {},
                roleList: [],
                factoryTree: [],
                fcIdSelected: '',
                roleIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                ischeck:true,
                role:[]
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr;
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        arr.push({
                            label: shops[i].deptName,
                            id: shops[i].deptID,
                            value: JSON.stringify(shops[i]),
                            deptLevel: shops[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        arr.push({
                            label: vsms[i].deptName,
                            id: vsms[i].deptID,
                            value: JSON.stringify(vsms[i]),
                            deptLevel: vsms[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        arr.push({
                            label: lines[i].deptName,
                            id: lines[i].deptID,
                            value: JSON.stringify(lines[i]),
                            deptLevel: lines[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            hasShopSelect: function() {
                if(this.roleIdSelected.length > 0) {
                    var role = JSON.parse(this.roleIdSelected)
                    if("shop" == role.roleLevel || "vsm" == role.roleLevel||"line" == role.roleLevel)
                        return true
                }
                return false
            },
            hashSectionSelect: function() {
                if(this.roleIdSelected.length > 0) {
                    var role = JSON.parse(this.roleIdSelected)
                    if("vsm" == role.roleLevel||"line" == role.roleLevel)
                        return true
                }
                return false
            },
            hashLineSelect: function() {
                if(this.roleIdSelected.length > 0) {
                    var role = JSON.parse(this.roleIdSelected)
                    if("line" == role.roleLevel)
                        return true
                }
                return false
            }
        },
        created() {
            this.init()
        },
        /*activated() {
            if(this.$route.params.row != undefined && this.$route.params.row != ''){
                this.userParam = this.$route.params.row
                sessionStorage.setItem('editUserParam', JSON.stringify(this.userParam))
            }else{
                this.userParam = JSON.parse(sessionStorage.getItem('editUserParam'))
            }
            this.rolebyId(this.userParam.userId)
        },
        mounted() {
            this.init()
        },*/
        methods:{
            init(){
                if(this.$route.params.row != undefined && this.$route.params.row != ''){
                    this.userParam = this.$route.params.row
                    sessionStorage.setItem('editUserParam', JSON.stringify(this.userParam))
                }else{
                    this.userParam = JSON.parse(sessionStorage.getItem('editUserParam'))
                }

                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if(role[i].factoryId == 0){
                        this.ischeck = false;
                        this.role = role[i]
                        break;
                    }else{
                        if(this.userInfo.factoryId == role[i].factoryId){
                            this.role = role[i]
                        }
                    }
                }
                this.rolebyId(this.userParam.userId)
                this.getData()
            },
            /*getRoleFcCode(){
                var fcCode = JSON.parse(this.roleIdSelected).fcCode
                for (let i = 0; i < this.factoryTree.length; i++) {
                    if (this.factoryTree[i].deptCode == fcCode){
                        this.fcIdSelected = JSON.stringify(this.factoryTree[i])
                    }
                }
            },*/
            fcChange(){
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.roleIdSelected = ''
                this.getRoles()
            },
            rolebyId(userId){
                let options = {
                    method: 'GET',
                    url: this.$api.userRole + userId
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        if(response.data.hasOwnProperty('roles')){
                            this.userRolesList = response.data.roles
                        }else{
                            this.userRolesList = []
                        }
                    }
                })
            },
            getRoles(){
                var params = {}
                if(this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }else{
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.listRole,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100) {
                        this.roleList = []
                        if(this.ischeck == false){
                            this.roleList = response.data
                        }else{
                            var aa = response.data
                            for (let i = 0; i < aa.length; i++) {
                                if(aa[i].roleCode != 'admin'){
                                    this.roleList.push(aa[i])
                                }
                            }
                        }
                    }
                })
            },
            getData(){
                let options = {
                    method: 'GET',
                    url : this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        if(this.factoryTree[i].deptID == this.role.factoryId){
                            this.fcIdSelected = JSON.stringify(this.factoryTree[i])
                        }
                    }
                    this.getRoles()
                })
            },
            editUser(){
                console.log(this.userParam)
                var self = this
                if(self.userParam.userName == null || self.userParam.userName == ''){
                    self.$message.error(this.$t('User.name'))
                    return
                }
                if(self.userParam.userAccount == null || self.userParam.userAccount == ''){
                    self.$message.error(this.$t('User.JobNo'))
                    return
                }
                var queryData = {
                    userId:self.userParam.userId,
                    userName:self.userParam.userName,
                    userAccount:self.userParam.userAccount,
                    userPhone:self.userParam.userPhone,
                    userEmail:self.userParam.userEmail,
                    isActive:self.userParam.isActive
                }
                let options = {
                    method: 'POST',
                    data: queryData,
                    url: this.$api.userSave
                }
                this.$http.request(options).then(response => {
                    console.log(response)
                    if(response.data){
                        self.$message.success(this.$t('base.SuccessfullyUpdated'))
                        this.$router.push({ path: '/User' })
                    }else{
                        self.$message.error(response.message)
                    }
                })
            },
            addUserRoleShow(){
                this.dialogVisible = true
            },
            addUserRole(){
                var self = this
                var querydata = {
                    userId: self.userParam.userId,
                    roleId: JSON.parse(self.roleIdSelected).roleId,
                    factoryId: JSON.parse(self.fcIdSelected).deptID,
                    fcCode: JSON.parse(self.fcIdSelected).deptCode
                }
                /*for(var i = 0; i < self.userRolesList.length; i++) {
                    if(self.userRolesList[i].factoryId != querydata.factoryId){
                        self.$message.error("用户只能一个工厂")
                        return
                    }
                }*/
                if(JSON.parse(self.roleIdSelected).roleLevel == 'factory') {
                    for (var i = 0; i < self.userRolesList.length; i++) {
                        if (self.userRolesList[i].roleId == querydata.roleId &&
                            self.userRolesList[i].factoryId == querydata.factoryId) {
                            self.$message.error(this.$t('User.added'))
                            return
                        }
                    }
                }
                if(JSON.parse(self.roleIdSelected).roleLevel == 'shop') {
                    querydata['shopId'] = JSON.parse(self.shopSelected).deptID
                    querydata['shopCode'] = JSON.parse(self.shopSelected).deptCode
                    for(var i = 0; i < self.userRolesList.length; i++) {
                        if(self.userRolesList[i].roleId == querydata.roleId &&
                            self.userRolesList[i].factoryId == querydata.factoryId &&
                            self.userRolesList[i].shopId == querydata.shopId) {
                            self.$message.error(this.$t('User.added'))
                            return
                        }
                    }
                }
                if(JSON.parse(self.roleIdSelected).roleLevel == 'vsm') {
                    querydata['shopId'] = JSON.parse(self.shopSelected).deptID
                    querydata['shopCode'] = JSON.parse(self.shopSelected).deptCode
                    querydata['vsmId'] = JSON.parse(self.sectionSelected).deptID
                    querydata['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                    for(var i = 0; i < self.userRolesList.length; i++) {
                        if(self.userRolesList[i].roleId == querydata.roleId &&
                            self.userRolesList[i].factoryId == querydata.factoryId &&
                            self.userRolesList[i].shopId == querydata.shopId &&
                            self.userRolesList[i].vsmId == querydata.vsmId) {
                            self.$message.error(this.$t('User.added'))
                            return
                        }
                    }
                }
                if(JSON.parse(self.roleIdSelected).roleLevel == 'line') {
                    querydata['shopId'] = JSON.parse(self.shopSelected).deptID
                    querydata['shopCode'] = JSON.parse(self.shopSelected).deptCode
                    querydata['vsmId'] = JSON.parse(self.sectionSelected).deptID
                    querydata['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                    querydata['lineId'] = JSON.parse(self.lineSelected).deptID
                    querydata['lineCode'] = JSON.parse(self.lineSelected).deptCode
                    for(var i = 0; i < self.userRolesList.length; i++) {
                        if(self.userRolesList[i].roleId == querydata.roleId &&
                            self.userRolesList[i].factoryId == querydata.factoryId &&
                            self.userRolesList[i].shopId == querydata.shopId &&
                            self.userRolesList[i].vsmId == querydata.vsmId &&
                            self.userRolesList[i].lineId == querydata.lineId) {
                            self.$message.error(this.$t('User.added'))
                            return
                        }
                    }
                }
                let options = {
                    method: 'POST',
                    data:querydata,
                    url: this.$api.addUserRole
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        this.$message.success(this.$t('base.SuccessfullyAdded'));
                        this.dialogVisible = false
                        this.rolebyId(this.userParam.userId)
                    }else if(response.status == 101){
                        this.$message.error(response.message);
                    }
                })
            },
            deleterole(scope){
                console.log(scope)
                this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'GET',
                                url: this.$api.deleteUserRole + scope.row.syrId
                            })
                            .then(response => {
                                this.rolebyId(this.userParam.userId)
                                this.$message.success(this.$t('msg.DeletionSucceeded'));
                            })
                            .catch(err => {
                                this.$message.error(this.$t('msg.DeleteFailed'));
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.cancel')
                        })
                    })
            }
        }
    }
</script>

<style scoped>

</style>
